<template>
    <form >
        <div class="input-group">
            <input v-model="busqueda.valor" type="search" class="form-control"
                :placeholder="esBeneficio ? 'Comercio' : 'Nombre'" aria-label="Valor a buscar"
                aria-describedby="icono-buscar" v-on:search="clickBuscar()" />

            <button class="input-group-text" type="submit" v-on:click.prevent="clickBuscar()">
                <font-awesome-icon :icon="Icons.BUSCAR" />
            </button>
        </div>
    </form>
</template>
<script>
import { Icons as IconConstants } from "../../../../constants";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

import { BuscarPor, OrdenarPor } from "../../../../data/enums";
import { Util } from "../../../../util";


export default {
    components: {
        FontAwesomeIcon,
    },
    props: {
        esBeneficio: Boolean,
        onSearch: Function,
    },
    data() {
        return {
            // Objeto de busqueda
            busqueda: {
                valor: null,
                buscarPor: BuscarPor.comercio,
                ordenarPor: OrdenarPor.relevancia
            },
            // Objeto para guardar busquedas realizadas
            busquedasCacheadas: {
                beneficios: null,
                comercios: null,
            },
        };
    },
    computed: {
        /**Constantes de iconos */
        Icons() {
            return IconConstants;
        },
    },
    methods: {
        // Realiza la busqueda
        clickBuscar() {
            // Se fija que tenga contenido
            if (this.busqueda.valor) {
                // Se fija si hay que hacer la busqueda o ya existe
                if (this.tratarActualizacion()) {
                    this.busqueda = {
                        valor: this.busqueda.valor,
                        buscarPor: BuscarPor.comercio,
                        ordenarPor: OrdenarPor.relevancia
                    };
                    this.onSearch(this.busqueda);
                }
            }

            // No hay contenido, mostrar listado original
            else {
                // Se fija si hay que hacer la busqueda o ya existe
                if (this.tratarActualizacion()) {
                    this.busqueda = {};
                    this.onSearch(this.busqueda);
                }
            }

        },

        // Devuelve true si es necesario recargar o false si no es necesario
        tratarActualizacion() {
            if (this.esBeneficio) {
                // Beneficios
                if (this.verSiEsDistinta(this.busquedasCacheadas.beneficios)) {
                    this.busquedasCacheadas.beneficios = Util.copiaProfunda(this.busqueda);
                    return true;
                }
                else return false;
            }
            else {
                // Comercios
                if (this.verSiEsDistinta(this.busquedasCacheadas.comercios)) {
                    this.busquedasCacheadas.comercios = Util.copiaProfunda(this.busqueda);
                    return true;
                }
                else return false;
            }
        },

        // Verdadero si la búsqueda cacheada es distinta a la actual
        verSiEsDistinta(cacheada) {
            if (cacheada == null) return true;

            if (cacheada.valor != this.busqueda.valor) return true;

            return false;
        }

    },
    mounted() {
        if (this.esBeneficio) {
            this.busquedasCacheadas.beneficios = Util.copiaProfunda(this.busqueda);
        }
        else {
            this.busquedasCacheadas.comercios = Util.copiaProfunda(this.busqueda);
        }
    }
};
</script>
<style scoped></style>